import React from 'react'

import SEO from '../../components/shared/SEO'
import NewsArchiveTemplate from '../../components/templates/NewsTemplate/NewsArchive'
import {
  Maybe,
  NewsCollectionDocument,
  NewsCollectionFieldsFragment,
  NewsCollectionQuery,
  NewsOrder,
} from '../../generated/graphql'
import { initializeApollo } from '../../utils/ApolloClient'

type Props = {
  newsItems: Maybe<NewsCollectionFieldsFragment>[]
}

const NewsPage: React.FC<Props> = ({ newsItems }) => (
  <>
    <SEO
      title="お知らせ | RYDE株式会社"
      description="RYDE株式会社のお知らせページです。ニュースやイベント・セミナーなどのお知らせを掲載しております。"
      openGraph={{
        images: [
          {
            url: 'https://ryde-inc.jp/og_image.png',
          },
        ],
        type: 'website',
        url: 'https://ryde-inc.jp/',
        site_name:
          'RYDE株式会社 | 二次交通をわかりやすく、使いやすく、そして持続可能に',
        locale: 'ja_JP',
      }}
    />
    <NewsArchiveTemplate newsItems={newsItems} />
  </>
)

export async function getStaticProps() {
  const apolloClient = initializeApollo()
  const { data, error } = await apolloClient.query<NewsCollectionQuery>({
    query: NewsCollectionDocument,
    variables: {
      order: [NewsOrder.DateDesc],
      limit: 1000,
    },
  })

  if (error || !data.newsCollection) {
    throw error
  }

  return {
    props: {
      newsItems: data.newsCollection.items,
    } as Props,
    revalidate: 60,
  }
}

export default NewsPage
